import styled from 'styled-components';
import Button from '../button/Button';
import { MaxContentWrapper } from '../max-content-wrapper/MaxContentWrapper';
export const Header = styled.header `
  position: ${({ shouldStick }) => (shouldStick ? 'sticky' : 'absolute')};
  top: 0;
  left: 0;

  width: 100%;

  padding: 1.6rem;

  box-shadow: ${({ theme }) => theme.shadows.sm};
  background-color: ${({ theme }) => theme.colors.surface.default};
  z-index: ${({ theme }) => theme.zIndex.highest};
  ${({ theme }) => theme.media.tablet `
    padding: 1.6rem 2rem;
  `}
`;
export const Container = styled(MaxContentWrapper) `
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const BitnetLogo = styled.img `
  width: 8.4rem;
  display: none;
  ${({ theme }) => theme.media.tablet `
    display: inline;
    width: 12rem;
  `}
`;
export const HeaderButton = styled(Button) `
  padding: 0 4rem;

  color: ${({ theme }) => theme.colors.interactive.brandColor};
  ${({ theme }) => theme.media.tablet `
     height: 4.8rem;
  `}
`;
export const HeaderRightWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const LanguageWrapper = styled.div `
  margin-right: 1.6rem;
  order: -1;

  ${({ theme }) => theme.media.tablet `
    order: 0;
    margin-left: 1.6rem;
    margin-right: unset;
  `}
`;
export const MobileLogo = styled.img `
  height: 3rem;
  width: 2.8rem;

  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
//# sourceMappingURL=styles.js.map